import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps, Prices } from "@b2bportal/core-types";
import { Trans } from "@hopper-b2b/i18n";
import { useI18nContext } from "@hopper-b2b/i18n";
import { usePriceDisplay } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarPriceDisplay.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type CarPriceDisplayProps = PlatformComponentProps & {
  days?: number;
  prices: {
    total: Prices;
    perDay: Prices | undefined;
  };
};

const COMPONENT_KEY = CoreCarsComponent.CarPriceDisplay;
export const CarPriceDisplay: React.FC<CarPriceDisplayProps> = ({
  prices,
  className,
}) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const {
    priceText: totalPriceText,
    rewardsText: totalRewardsText,
    showRewardPrice,
  } = usePriceDisplay({ prices: prices.total });
  const { priceText: dailyPriceText, rewardsText: dailyRewardsText } =
    usePriceDisplay({ prices: prices.perDay });

  return (
    <span className={clsx(block, className)}>
      {showRewardPrice ? (
        <>
          {dailyRewardsText && (
            <span className={cn("per-day")}>
              {t("core-cars.perDayPoints", { points: dailyRewardsText })}
            </span>
          )}
          <Trans
            i18nKey={"core-cars.totalInRewardsOrPrice"}
            components={{
              rewards: <span className={cn("price")} />,
              price: <span className={cn("subtext")} />,
            }}
            values={{
              rewards: totalRewardsText,
              price: totalPriceText,
            }}
          />
        </>
      ) : (
        <>
          {dailyPriceText && (
            <span className={cn("per-day")}>
              {t("core-cars.perDayPrice", { price: dailyPriceText })}
            </span>
          )}
          <Trans
            i18nKey={"core-cars.totalInPrice"}
            components={{
              price: <span className={cn("price")} />,
            }}
            values={{
              price: totalPriceText,
            }}
          />
        </>
      )}
    </span>
  );
};
